import './App.css';
import BrowserRouters from './routes/BrowserRouters';
import './styles/app.scss';
export default function App() {
  return <BrowserRouters />;
}
